import { combineReducers } from "@reduxjs/toolkit";
import HMDashboardReducers from "./index";

export default combineReducers({
    HMDashboardPage: HMDashboardReducers
})